// extracted by mini-css-extract-plugin
module.exports =  {"link":"_Z7OVIW","pricing-factor":"r3UQ2sc","pricingFactor":"r3UQ2sc"};